<template>
  <div>
    <div :id="id" :style="{ height: height - 32 + 'px' }" />
    <NoDataOverlay :model-value="!(value && value.length)" />
  </div>
</template>
  
  <script>
import * as echarts from "echarts";
import themeJson from "@/assets/echarts-themes/oceanic-balanced.json";
import { v4 as uuidv4 } from "uuid";
import NoDataOverlay from "@/components/atoms/analytics/NoDataOverlay.vue";

export default {
  name: "CampaignLatest5Performance",
  components: {
    NoDataOverlay,
  },
  props: {
    id: {
      type: String,
      default: `real-time-performance-${uuidv4()}`,
    },
    value: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      chartInstance: null,
      resizeObserver: null,
    };
  },
  watch: {
    value: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart();
    this.observeResize();
  },
  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },

  methods: {
    renderChart() {
      const chartDom = document.getElementById(this.id);
      if (!chartDom) return;

      const chart = echarts.init(chartDom, themeJson.themeName);
      chart.setOption(this.getOptions());

      this.chartInstance = chart;
    },
    observeResize() {
      const chartDom = document.getElementById(this.id);
      if (!chartDom) return;

      this.resizeObserver = new ResizeObserver(() => {
        requestAnimationFrame(() => {
          this.chartInstance?.resize();
        });
      });

      this.resizeObserver.observe(chartDom);
    },
    getOptions() {
      console.log("this.value", this.value);

      return {
        title: {
          text: "Campaign Performance",
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          bottom: 0,
          data: ["Impressions", "Views", "Clicks"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.value.map((item) => item.campaign),
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "Impressions",
            type: "bar",
            data: this.value.map((item) => item.impressions),
          },
          {
            name: "Views",
            type: "bar",
            data: this.value.map((item) => item.views),
          },
          {
            name: "Clicks",
            type: "bar",
            data: this.value.map((item) => item.clicks),
          },
        ],
      };
    },
  },
};
</script>
  
  <style scoped>
.inventory-item-pie-chart {
  width: 100%;
  font-family: Roboto, sans-serif;
}
</style>
  